import {
  type FeatureFlagKey,
  featureFlagsQueryKeys,
  getCachedFeatureFlags,
  requestFeatureFlags,
} from '@lib/featureFlags/featureFlagsApi';
import { useQuery } from '@tanstack/react-query';

export const useFeatureFlag = (
  key: FeatureFlagKey | string,
  defaultValue = false
): boolean => {
  const { data } = useQuery({
    queryKey: featureFlagsQueryKeys.all,
    queryFn: requestFeatureFlags,
    staleTime: 5 * 60 * 1000,
    gcTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    initialData: getCachedFeatureFlags,
  });

  const value = data?.[key];
  return value === undefined ? defaultValue : value;
};
